import * as React from "react";
import { SignatureCell } from "../GridComponents";
import EditLedgerCardSetting from "./EditLedgerCardSetting";
import List from "components/Setting/List";
import { updateLedgerCardSetting, useLedgerCardSettings } from "services/ledgerCardSettingsService";
import { parsePostingStyle } from "./styleUtils";

const makeColorCell = (colorKey) => (props) => {
  const parsed = parsePostingStyle(props.dataItem.style);
  const colour = parsed[colorKey];
  const hasColor = colour && colour !== "none" && colour.trim() !== "";

  return (
    <td className="text-center align-middle">
      {hasColor ? (
        <div
          style={{
            width: "20px",
            height: "20px",
            backgroundColor: colour,
            border: "1px solid #ccc",
            borderRadius: "3px",
            margin: "0 auto",
          }}
        />
      ) : (
        <div
          style={{
            width: "18px",
            height: "18px",
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "3px",
            position: "relative",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "22px",
              height: "2px",
              background: "#f8c2c2",
              transform: "translate(-50%, -50%) rotate(45deg)",
              borderRadius: "1px",
            }}
          />
        </div>
      )}
    </td>
  );
};

const TextColorCell = makeColorCell("color");
const RowColorCell = makeColorCell("backgroundColor");

const LedgerCardSettingsList = () => {
  const { data: gridData, loading } = useLedgerCardSettings();

  return (
    <List
      editAction={updateLedgerCardSetting}
      editFormComponent={EditLedgerCardSetting}
      component="ledgerCardSettings"
      columns={[
        { field: "postingName", title: " ", cell: SignatureCell, width: "80" },
        { field: "postingName", title: "Posting Types" },
        {
          cell: TextColorCell,
          title: "Text Color",
          field: "style",
          width: "120",
          headerClassName: "grid-header-center",
        },
        {
          cell: RowColorCell,
          title: "Row Color",
          field: "style",
          width: "120",
          headerClassName: "grid-header-center",
        },
      ]}
      gridData={gridData}
      loading={loading}
    />
  );
};

export default LedgerCardSettingsList;
